module.exports = __webpack_public_path__ + "static/media/Bacarrat.3d1c0332.jpeg";